import { Dialog, styled } from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  ".MuiDialog-container .MuiPaper-root": {
    boxShadow: "none",
  },
}));
